import { defineMessages } from 'react-intl';

export const messages: {
	liveDoc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	attachment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	blogpost: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	comment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	page: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	whiteboard: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	liveDoc: {
		id: 'live_doc_type',
		defaultMessage: 'Live Doc',
		description:
			'Content type badge shown on a recommended document result card in the Quick Find dialog to indicate the item is a Live Doc (a collaborative real-time document).',
	},
	attachment: {
		id: 'attachment_type',
		defaultMessage: 'Attachment',
		description:
			'Content type badge shown on a recommended document result card in the Quick Find dialog to indicate the item is a file attachment.',
	},
	blogpost: {
		id: 'blogpost_type',
		defaultMessage: 'Blogpost',
		description:
			'Content type badge shown on a recommended document result card in the Quick Find dialog to indicate the item is a Confluence blog post.',
	},
	comment: {
		id: 'comment_type',
		defaultMessage: 'Comment',
		description:
			'Content type badge shown on a recommended document result card in the Quick Find dialog to indicate the item is a comment on a page or issue.',
	},
	page: {
		id: 'page_type',
		defaultMessage: 'Page',
		description:
			'Content type badge shown on a recommended document result card in the Quick Find dialog to indicate the item is a Confluence page.',
	},
	whiteboard: {
		id: 'whiteboard_type',
		defaultMessage: 'Whiteboard',
		description:
			'Content type badge shown on a recommended document result card in the Quick Find dialog to indicate the item is a Confluence whiteboard.',
	},
});
